import { fromJS, Map } from 'immutable';
import { combineReducers } from 'redux-immutable'
import getCurrentWeeksArray from '../../functions/getCurrentWeeksArray';
import flyerReducer from './flyerReducer';
import printTypesReducer from './printTypesReducer';
import weekProgramFlyerReducer from './weekProgramFlyerReducer';
import generalSettingsReducer from './generalSettings';
import { dummyReducerFacory } from '../helpers';
import newspaperReducer from './newspaperReducer';


const WEEKS = getCurrentWeeksArray()
const INIT_STATE = Map({})
const oldWeeks = WEEKS.map(weekObj => weekObj.isoWeek)


const combinedReducer = combineReducers({
    weeks: dummyReducerFacory(fromJS(WEEKS)),
    generalSettings: generalSettingsReducer,
    printTypes: printTypesReducer(WEEKS),
    flyer:  flyerReducer(WEEKS),
    weekProgramFlyer:  weekProgramFlyerReducer(oldWeeks),
    newspaper:  newspaperReducer(WEEKS),
})

const printServerDataReducer = (state = INIT_STATE, action) => combinedReducer(state, action)

export default printServerDataReducer;